var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"toolbar-export",attrs:{"title":_vm.title}},[_c('IconAtom',{attrs:{"type":"export"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }